export const LOG_TYPE_CODES = {
	A: { id: "A", description: "All" },
	I: { id: "I", color: "#3f51b5", description: "Info" },
	E: { id: "E", color: "#f44336", description: "Error" },
	W: { id: "W", color: "#E69C00", description: "Warning" },
};
